import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import MyOrdersPage from './components/MyOrdersPage';

app.initializers.add('pablomartin-wp-orders', () => {
  app.routes['myOrders'] = { path: '/my-orders', component: MyOrdersPage };

  extend(SessionDropdown.prototype, 'items', function (items) {
    items.add(
      'myOrders',
      LinkButton.component(
        {
          icon: 'fas fa-shopping-bag',
          href: app.route('myOrders'),
        },
        'My Orders'
      ),
      40
    );
  });
});
